// extracted by mini-css-extract-plugin
module.exports = {"v-message":"v-message_v-message_3YKuM","logo":"v-message_logo_3VlSB","heading":"v-message_heading_2-l2m","detail":"v-message_detail_10E_x"};